<template>
  <v-app class="fixNotchPaddingTop" style="overflow: hidden; height: 100vh;">

    <!-- Sizes your content based upon application components -->
    <v-main>

      <!-- Provides the application the proper gutter -->
      <v-container fluid style="background-color: #F0F4F0; height: 100vh; padding: 0px; overflow: hidden;">

        <!-- If using vue-router -->
        <keep-alive>
          <router-view></router-view>
        </keep-alive>

      </v-container>

    </v-main>

  </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
//import styles from './assets/App.css'
import api from './api/icoev.js';
import BaseModule from './components/common/BaseModule';
import cordova from './api/cordova';

export default {
  name: 'App',
  mixins: [BaseModule],
  components: {
  },

  data () {
    return {
    }
  },
	mounted: function () {
		var me = this;

		this.$nextTick(() => {
			window.$vue.$on('device-info-updated', me.deviceInfochanged);
			cordova.init();
    });
	},
  methods: {
		deviceInfochanged() {
			console.log("*** device-info-updated event -> registerDevice() called!");
			this.registerDevice();
		},
		registerDevice: function() {			
			/*if (this.$store.state.icoev.deviceRegistered) {
				console.log("Device already registered!");
				return;
			}*/

			var device = this.$store.state.icoev.device;
			var user = this.$store.state.icoev.user;

			console.log("*** Device info -> [ device: " + JSON.stringify(device) + " - user: " + JSON.stringify(user) + " ]");
			
			if (!device.uuid || !device.platform || !device.version || !device.token || !user) {
				console.log("*** Device info is missing!");
				return;
			}

			console.log("*** Device info is OK!");
			
			/*if (this.$store.state.icoev.deviceRegistered) {
				console.log("Device already registered!");
				return;
			}*/	
				
			device.username = user.numcol;

			api.storeDevice(device,
			res=> {
				if (!res) {
					console.log("*** Device is null!");
					return;
				}

				this.$store.commit('icoev/setDevice', res);

				console.log("*** Device registered! [ device: " + JSON.stringify(res) + " ]");
			});	
		},
  },
	computed: {
		userChanged() {
      return this.$store.state.icoev.user;
		}
	},
	watch: {
		userChanged() {
			if (this.$store.state.icoev.user) {
				console.log("*** userChanged -> registerDevice() called!");
				this.registerDevice();
			}
		}
	}
}
</script>
